import { FlexContainer, TaggableChip } from '@act/storybook';
import { Typography } from '@mui/material';

export interface ReportDataRequirementTagsProps {
  requirements: string[];
}

/**
 * Renders section library data requirement keys as read-only tags.
 * @param requirements - Field keys required to populate the section snapshot.
 */
const ReportDataRequirementTags = ({
  requirements,
}: ReportDataRequirementTagsProps) => {
  if (!requirements.length) {
    return null;
  }

  return (
    <FlexContainer
      direction="column"
      gap={1}
      width="100%"
      height="auto"
      overflowAllVisible={true}
    >
      <Typography
        variant="overline"
        color="text.secondary"
        style={{ letterSpacing: '0.08em' }}
      >
        Data requirements
      </Typography>
      <FlexContainer
        direction="row"
        gap={0.75}
        flexWrap={true}
        height="auto"
        overflowAllVisible={true}
      >
        {requirements.map(requirement => (
          <TaggableChip
            key={requirement}
            label={requirement}
            color="neutral"
            variant="outlined"
            isTag
            size="small"
          />
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

export default ReportDataRequirementTags;
